// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin_0 {
  margin: 0;
}
body {
  background-color: var(--ColorShadow);
  overflow: auto !important;
  overflow-y: hidden;
  padding: 0px;
  margin: 0px;
  width: 97%;
}
.home_container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
.body_main {
  margin-top: 0px;
  margin-left: 6rem;
  margin-right: 1rem;
  transition: 500ms;
  display: flex;
  width: auto;
  flex-direction: column;
  gap: 20px;
}
.container_home {
  margin: 1rem;
  width: 100%;
}

.first_row {
  display: flex;
  flex-direction: row;
  margin: 1rem;
  gap: 20px;
  width: 100%;
}
.second_row {
  display: flex;
  flex-direction: row;
  margin: 1rem;
  gap: 20px;
  width: 100%;
}
.third_row {
  display: flex;
  flex-direction: row;
  margin: 1rem;
  gap: 20px;
  width: 100%;
}

/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .first_row {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .second_row {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .third_row {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }
  .body_main {
    margin-right: 5rem;
  }

  .home_container {
    flex-direction: column;
    align-items: stretch;
  }
  .body_main {
    margin: 1rem;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
  .body_main {
    width: 100%;
    margin-top: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home2/Home.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA,2GAA2G;AAC3G;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;AACF;AACA,kGAAkG;AAClG;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".margin_0 {\n  margin: 0;\n}\nbody {\n  background-color: var(--ColorShadow);\n  overflow: auto !important;\n  overflow-y: hidden;\n  padding: 0px;\n  margin: 0px;\n  width: 97%;\n}\n.home_container {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n.body_main {\n  margin-top: 0px;\n  margin-left: 6rem;\n  margin-right: 1rem;\n  transition: 500ms;\n  display: flex;\n  width: auto;\n  flex-direction: column;\n  gap: 20px;\n}\n.container_home {\n  margin: 1rem;\n  width: 100%;\n}\n\n.first_row {\n  display: flex;\n  flex-direction: row;\n  margin: 1rem;\n  gap: 20px;\n  width: 100%;\n}\n.second_row {\n  display: flex;\n  flex-direction: row;\n  margin: 1rem;\n  gap: 20px;\n  width: 100%;\n}\n.third_row {\n  display: flex;\n  flex-direction: row;\n  margin: 1rem;\n  gap: 20px;\n  width: 100%;\n}\n\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .first_row {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n  .second_row {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n  .third_row {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n  .body_main {\n    margin-right: 5rem;\n  }\n\n  .home_container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .body_main {\n    margin: 1rem;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n  .body_main {\n    width: 100%;\n    margin-top: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
